import {createSelector} from '@reduxjs/toolkit'
import { DOCUMENT_TYPE_FORMS_AGREEMENTS, DOCUMENT_TYPE_NOTICES_LETTERS, DOCUMENT_TYPE_SURETY_BONDS } from '../../app/constants'

//serverRequestStatus
const supportingDocumentsSelector = createSelector(
    [state => state.components, 
    state => state.primaryAgencyApplication],
    (components, businessLicenceApplicationData) => {
        const primaryApplication = businessLicenceApplicationData.application
        const {supportingDocuments} = components
        let formsAgreements = []
        let noticesLetters = []
        let suretyBondDocs = []

        if(primaryApplication?.documents
            && Array.isArray(primaryApplication.documents)) {

            primaryApplication.documents.forEach(document => {

                if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) { 
                    formsAgreements.push(document)
                } else if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) {
                    noticesLetters.push(document)
                } else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                    suretyBondDocs.push(document)
                }
            })
        }
           
        return {
            ...supportingDocuments,
            formsAgreements,
            noticesLetters,
            suretyBondDocs,
            applicationSavingRequestStatus : businessLicenceApplicationData.serverRequestStatus
        }
    }
)
export const supportingDocumentsSelect = state => ({
    supportingDocuments : supportingDocumentsSelector(state)
})

export function populateSupportingDocumentsData(formsAgreements, noticesLetters) {

    // let fs = ""
    // let nl = ""

    // if(formsAgreements) {
    //     fs = formsAgreements.map((f) => f.filename).join(" , ")
    // }

    // if(noticesLetters) {
    //     nl = noticesLetters.map((f) => f.filename).join(" , ")
    // }

    return [
        {"Forms or agreements" : formsAgreements ? formsAgreements.filter(file => file.changeType !== "DELETE") : []},
        {"Notices or letters" : noticesLetters ? noticesLetters.filter(file => file.changeType !== "DELETE") : []}
    ]
}
